import React, { Component } from 'react';
import { Map, List, fromJS } from 'immutable';
import { injectIntl, defineMessages } from 'react-intl';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as common from 'libs/commonFunc';
import * as targetActions from 'modules/target';

import { AdminTargetList } from 'components';

let SEARCH_VALUE = '';
class CtAdminTargetList extends Component {
  constructor(props) {
    super(props);

    // 검색 기록 유지
    const { paramData } = this.props;
    const filterData = paramData.get('filter').toJS();
    let searchTypeData = 'searchAll';
    let searchTextData = '';
    if (Object.keys(filterData).length) {
      const searchOptions = [
        'searchAll',
        'serviceNo',
        'serviceName',
        'targetNo',
        'targetName',
        'targetEmail',
        'targetPhone',
        'targetDivisionArray',
        'targetPositionArray',
        'tagList'
      ];
      searchOptions.map(option => {
        if (filterData[option]) {
          searchTypeData = option;
          searchTextData = filterData[option];
        }
      });
    }

    this.state = {
      loading: false,
      // data: [],
      // pages: null,
      fromNowRegDate: false,
      fromNowPasswdUpdateDate: false,
      fitRowCount: 0,
      currentPage: 0,
      pageSize: 0,
      searchType: searchTypeData,
      searchText: searchTextData
    };
  }

  componentWillMount() {
    // 화면 사이즈(높이)에 해당하는 리스트의 개수 설정
    let fitRowCount = Math.trunc((window.innerHeight - 315) / 48);
    fitRowCount = fitRowCount < 5 ? 5 : fitRowCount;

    this.handleInitFilter();
    this.setState({ pageSize: fitRowCount, fitRowCount });
  }

  componentDidUpdate(prevProps) {
    const { needReload, paramData } = this.props;

    if (
      needReload !== prevProps.needReload ||
      // parameter가 변경되었을때
      paramData !== prevProps.paramData
    ) {
      this.getTarget();
    }
  }

  getTarget = async () => {
    if (!this.state.loading) {
      this.setState({ loading: true });

      try {
        const { TargetActions, paramData } = this.props;
        const { currentPage, pageSize } = this.state;
        const params = {
          filter: JSON.stringify(paramData.get('filter')),
          sort: JSON.stringify(paramData.get('sort')),
          offset: pageSize * (currentPage < 0 ? 0 : currentPage), // page 는 0 번 부터 시작
          limit: pageSize < 1 ? 20 : pageSize,
          refresh: true
        };

        await TargetActions.getTarget(params);
      } catch (e) {
        console.log(e);
      }

      this.setState({ loading: false });
    }
  };

  // 필터 처리
  // 정렬 처리
  handleFetchData = ({ ...rest }) => {
    const { sorted } = rest;
    const sort = [];
    if (sorted && Array.isArray(sorted)) {
      // 정렬이 적용됨
      for (let i = 0; i < sorted.length; i++) {
        const data = sorted[i];
        sort.push({ field: data.id, order: data.desc ? 'DESC' : 'ASC' });
      }
    }

    const { TargetActions } = this.props;
    TargetActions.changeTargetParam({
      name: 'sort',
      value: fromJS(sort)
    });
  };

  // 검색 타입 선택
  handleSearchOptions = (e, { value }) => {
    this.setState({ searchType: value });
  };

  // 검색어 입력
  handleChangeSearch = e => {
    this.setState({ searchText: e.target.value });
  };

  // 검색
  handleOnSearch = e => {
    if (
      e.key === 'Enter' ||
      e.target.id === 'bt-search-input' ||
      e.target.parentNode.id === 'bt-search-input' ||
      e.target.parentNode.parentNode.id === 'bt-search-input'
    ) {
      const searchType = this.state.searchType;
      const searchValue = SEARCH_VALUE;

      const { TargetActions, paramData } = this.props;
      const filter = paramData.get('filter').toJS();

      if (searchValue !== filter[searchType]) {
        // 검색 타입 제거
        const searchOptions = [
          'searchAll',
          'serviceNo',
          'serviceName',
          'targetNo',
          'targetName',
          'targetEmail',
          'targetPhone',
          'targetDivisionArray',
          'targetPositionArray',
          'tagList'
        ];

        searchOptions.map(option => delete filter[option]);

        if (searchValue !== '') {
          filter[searchType] = searchValue;
        }

        let arrayReq = {};
        this.setState({ currentPage: 0 });

        if (searchType === 'targetDivisionArray') {
          arrayReq = { targetDivisionArray: [searchValue] };
          TargetActions.changeTargetParam({
            name: 'filter',
            value: fromJS(arrayReq)
          });
        } else if (searchType === 'targetPositionArray') {
          arrayReq = { targetPositionArray: [searchValue] };
          TargetActions.changeTargetParam({
            name: 'filter',
            value: fromJS(arrayReq)
          });
        } else {
          TargetActions.changeTargetParam({
            name: 'filter',
            value: fromJS(filter)
          });
        }
      }
    }
  };

  // 개별 필터
  handleChangeFilter = (column, value, isMulti) => {
    const { TargetActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    // 멀티 선택 필터
    if (isMulti) {
      if (typeof filter[column] === 'undefined') {
        filter[column] = value;
      } else if (Number(filter[column]) === Number(value)) {
        delete filter[column];
      } else {
        if (Number(value) & Number(filter[column])) {
          filter[column] = Number(filter[column]) - Number(value);
        } else {
          filter[column] = Number(filter[column]) + Number(value);
        }
      }
      // 단일 선택 필터
    } else {
      if (filter[column] === value) {
        delete filter[column];
      } else {
        filter[column] = value;
      }
    }

    this.setState({ currentPage: 0 });
    TargetActions.changeTargetParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  // 날짜 필터
  handleChangeDateFilter = (type, data) => {
    const { TargetActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    if (data.startDate) {
      filter['start' + type] = data.startDate;
    }
    if (data.endDate) {
      filter['end' + type] = data.endDate;
    }

    this.setState({ currentPage: 0 });
    TargetActions.changeTargetParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  // 필터 초기화
  handleInitFilter = () => {
    this.setState({ searchType: 'searchAll', searchText: '' });

    const { TargetActions } = this.props;
    TargetActions.changeTargetParam({
      name: 'filter',
      value: Map({})
    });

    if (this.myTextInput && this.myTextInput.inputRef.value !== '') {
      this.myTextInput.inputRef.value = '';
    }
  };

  // 페이지 이동 처리
  handlePagination = pageNo => {
    this.setState({ currentPage: pageNo });
  };

  // 페이지 개수 처리 (페이지 초기화)
  handlePageSizeOnChange = (obj, value) => {
    this.setState({ pageSize: value.value, currentPage: 0 });
  };

  // 검색 입력값 받아오기
  takeSearchValue = searchValue => {
    SEARCH_VALUE = searchValue;
  };

  searchTextRef = ref => {
    this.myTextInput = ref;
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      loading,
      fromNowRegDate,
      fromNowPasswdUpdateDate,
      currentPage,
      pageSize,
      fitRowCount,
      searchType,
      searchText
    } = this.state;
    const { isAuth, targetDataByTargetNo, targetOrdering, totalPages, totalCount, paramData } = this.props;
    const { handleFetchData, takeSearchValue } = this;
    // 검색
    const {
      handleSearchOptions,
      handleChangeSearch,
      handleOnSearch,
      handleChangeFilter,
      handleChangeDateFilter,
      handleInitFilter,
      searchTextRef
    } = this;
    // 페이징
    const { handlePagination, handlePageSizeOnChange } = this;

    const filterData = paramData.get('filter').toJS();

    const fromNowClass = [];
    if (fromNowRegDate) {
      fromNowClass.push('from-now-reg-date');
    }
    if (fromNowPasswdUpdateDate) {
      fromNowClass.push('from-now-passwd-update-date');
    }

    let respData = {};
    let arrayData = null;
    if (targetDataByTargetNo && Map.isMap(targetDataByTargetNo)) {
      respData = targetDataByTargetNo.toJS();
      arrayData = Object.values(respData);
    }

    if (
      arrayData &&
      // respData.result === 1 &&
      // respData.success &&
      Array.isArray(arrayData) &&
      arrayData.length > 0
    ) {
      if (arrayData[0].rnum) {
        arrayData.map((targetDataByTargetNo, index) => {
          // 로그인 실패 데이터 처리
          if (targetDataByTargetNo) {
            arrayData[index].loginFail =
              defineMessages(formatMessage({ id: 'UserEdit_17', defaultMessage: '잠김' })) +
              ' (' +
              targetDataByTargetNo.loginFailCount +
              defineMessages(formatMessage({ id: 'TargetDetail_32', defaultMessage: '회' })) +
              ')';
          } else {
            arrayData[index].loginFail =
              defineMessages(formatMessage({ id: 'UserEdit_14', defaultMessage: '정상' })) +
              ' (' +
              targetDataByTargetNo.loginFailCount +
              defineMessages(formatMessage({ id: 'TargetDetail_32', defaultMessage: '회' })) +
              ')';
          }
        });
      }
    } else {
      // 응답 데이터 오류
    }

    const pageSizeArray = common.ArraySort(common.ArrayDuplicateRemove([5, 10, 20, 25, 50, 100, fitRowCount]));
    const pageSizeOptions = [];
    pageSizeArray.map(value => {
      pageSizeOptions.push({ text: value, value: value });
    });

    const searchOptions = [
      { key: 0, text: defineMessages(formatMessage({ id: 'Faq_1', defaultMessage: '전체' })), value: 'searchAll' },
      {
        key: 1,
        text: defineMessages(formatMessage({ id: 'AdminTargetList_3', defaultMessage: '서비스No' })),
        value: 'serviceNo'
      },
      {
        key: 2,
        text: defineMessages(formatMessage({ id: 'AdminTargetList_2', defaultMessage: '서비스명' })),
        value: 'serviceName'
      },
      { key: 3, text: 'No', value: 'targetNo' },
      {
        key: 4,
        text: defineMessages(formatMessage({ id: 'AdminTargetList_5', defaultMessage: '이름' })),
        value: 'targetName'
      },
      {
        key: 5,
        text: defineMessages(formatMessage({ id: 'AdminTargetList_6', defaultMessage: '이메일' })),
        value: 'targetEmail'
      },
      {
        key: 6,
        text: defineMessages(formatMessage({ id: 'AdminTargetList_7', defaultMessage: '연락처' })),
        value: 'targetPhone'
      },
      {
        key: 7,
        text: defineMessages(formatMessage({ id: 'AdminTargetList_8', defaultMessage: '소속' })),
        value: 'targetDivisionArray'
      },
      {
        key: 8,
        text: defineMessages(formatMessage({ id: 'AdminTargetList_9', defaultMessage: '직급' })),
        value: 'targetPositionArray'
      },
      {
        key: 9,
        text: defineMessages(formatMessage({ id: 'AdminTargetList_11', defaultMessage: '태그명' })),
        value: 'tagList'
      }
    ];

    return (
      <AdminTargetList
        isAuth={isAuth}
        fromNowClass={fromNowClass}
        manual
        data={arrayData}
        targetDataByTargetNo={targetDataByTargetNo}
        targetOrdering={targetOrdering}
        totalCount={totalCount}
        page={currentPage}
        pages={totalPages}
        pageSize={pageSize}
        defaultPageSize={fitRowCount}
        pageSizeOptions={pageSizeOptions}
        loading={loading}
        onFetchData={handleFetchData}
        // 검색 영역
        searchObj={{
          filterData: filterData,
          currentPage: currentPage,
          pageSize: pageSize,
          totalCount: totalCount,
          searchType: searchType,
          searchText: searchText,
          searchOptions: searchOptions,
          handleSearchOptions: handleSearchOptions,
          handleChangeSearch: handleChangeSearch,
          handleOnSearch: handleOnSearch,
          handleInitFilter: handleInitFilter,
          defaultPageSize: fitRowCount,
          pageSizeOptions: pageSizeOptions,
          handlePageSizeOnChange: handlePageSizeOnChange,
          searchTextRef: searchTextRef,
          takeSearchValue: takeSearchValue
        }}
        // 필터
        handleChangeFilter={handleChangeFilter}
        handleChangeDateFilter={handleChangeDateFilter}
        // 페이징 처리
        handlePagination={handlePagination}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    targetOrdering: state.target.get('targetOrdering'),
    targetDataByTargetNo: state.target.get('targetDataByTargetNo'),
    needReload: state.target.get('needReload'),
    totalPages: state.target.get('totalPages'),
    totalCount: state.target.get('totalTarget'),
    paramData: state.target.get('param'),
    isAuth: state.user.get('isAuth')
  };
};

const mapDispatchToProps = dispatch => ({
  TargetActions: bindActionCreators(targetActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtAdminTargetList));



// WEBPACK FOOTER //
// ./src/script/containers/admin/target/CtAdminTargetList.js